/**
 * Some Prebid bidder codes i.e. the values used for the `bidder` field in the Bid response object described in
 * http://prebid.org/dev-docs/publisher-api-reference.html#module_pbjs.getBidResponses
 */
export enum BidderCode {
    appnexus = "appnexus",
    spotx = "spotx"
}
